module.exports = __webpack_public_path__ + "static/media/default_cover.67c8d342.png";